import $ from 'jquery';
import { HTTP_STATUS_OK } from '../smartpak/httpstatus';
import client from './apiclient.js';

function combineResponses(responses) {
    return $.grep(responses, function(response) {
        return response.Status === HTTP_STATUS_OK;
    }).map(function(response) {
        return response.Content;
    });
}

function getResponses(responses) {
    return $.map(responses, function(response) {
        if (response.Content) {
            return response;
        }
        return response[0];
    });
}

function getPromises(productIds, api) {
    return $.map(productIds, function(id) {
        return api(id);
    });
}

function makeArray(collection) {
    return [].slice.call(collection);
}

function getDataForMultipleAPICalls(productIds, api) {
    var dfd = new $.Deferred();

    $.when.apply($, getPromises(productIds, api)).done(function() {
        dfd.resolve(combineResponses(getResponses(makeArray(arguments))));
    });

    return dfd.promise();
}

const product = {
    getProductClass: client.createConcatRequestMethod('get', '/api/product/getProductClass/'),
    getProductClassWithAttributes: client.createConcatRequestMethod(
        'get',
        '/api/product/getProductClassWithAttributes/'
    ),
    getProductsByProductClass: client.createConcatRequestMethod('get', '/api/product/getProductsByProductClass/'),
    get: function(productId, isAutoShip) {
        return client.get(
            '/api/product/getProductById?productId=' +
                productId +
                '&isAutoShip=' +
                (typeof isAutoShip !== 'undefined' ? isAutoShip : false)
        );
    },
    getProductClassDTOList: function(productIds) {
        return getDataForMultipleAPICalls(productIds, this.getProductClass);
    }
};

export default product;
